import { gboReservationPath } from './session';

export const reservationDriverInfoPath = [...gboReservationPath, 'driver_info'];
export const reservationProfileDetailsPath = [...gboReservationPath, 'profile_details'];
export const reservationProfileLoyaltyDataPath = [...reservationProfileDetailsPath, 'loyalty_data'];
export const reservationProfileLoyaltyNumberPath = [...reservationProfileLoyaltyDataPath, 'loyalty_number'];
export const reservationDriverFirstName = [...reservationDriverInfoPath, 'first_name'];
export const reservationDriverLastName = [...reservationDriverInfoPath, 'last_name'];
export const reservationDriverEmail = [...reservationDriverInfoPath, 'email_address'];
export const reservationDriverPhoneNumber = [...reservationDriverInfoPath, 'phone', 'phone_number'];
export const reservationToken = [...gboReservationPath, 'reservation_token'];
export const reservationVolatileCurrencyIndicator = [...gboReservationPath, 'volatile_currency_indicator'];
export const reservationLimitedAdvanceNoticeIndicator = [...gboReservationPath, 'limited_advance_notice_indicator'];
